import React, {useMemo} from 'react';
import api from 'api';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Formik from 'components/hook-form/Formik';
import {useDispatch, useSelector} from 'react-redux';
import {settingsActions, settingsSelectors} from 'redux/settings';
import {useCreateAdminRole} from 'redux/settings/hooks/useCreateAdminRole';
import {useDeleteAdminRole} from 'redux/settings/hooks/useDeleteAdminRole';
import {AdminRoles} from 'types/diplomat/settings/adminroles/AdminRoles';
// import {_roles} from 'types/diplomat/settings/Roles';
import AdminRolesForm from './AdminRolesForm';
import AsyncContainer from 'components/AsyncContainer';
import {enums} from 'types/enums';
import {useUpdateAdminRole} from 'redux/settings/hooks/useUpdateAdminRole';
import {IDiplomatObject} from 'types/DiplomatObject';
import useDictionary from 'common/hooks/useDictionary';

type Props = {
   onClose: (result?: string) => void;
};
const AdminRolesFormWrapper = ({onClose}: Props) => {
   // const select = (role: IRole) => console.debug('Select role', role);

   const _roles = useSelector(settingsSelectors.adminRoles);
   const isFetching = useSelector(settingsSelectors.isFetching);
   const dispatch = useDispatch();
   const {request, state: resourceTypes, loading} = useDictionary(api.resourcetypes);
   const [selected, select] = React.useState<IDiplomatObject>();

   React.useEffect(() => {
      dispatch(settingsActions.fetchAdminRoles);
   }, [dispatch]);

   React.useEffect(request, [request]);

   console.debug('Roles State', _roles);

   const openCreate = useCreateAdminRole();
   const onDelete = useDeleteAdminRole();
   const onUpdate = useUpdateAdminRole();

   const roles = useMemo(() => AdminRoles.cast({roles: _roles}), [_roles]);

   return (
      <AsyncContainer loading={isFetching}>
         <Formik onSubmit={onUpdate} initialValues={roles} enableReinitialize>
            <AdminRolesForm
               refetch={() => dispatch(settingsActions.fetchAdminRoles)}
               onCreate={openCreate}
               onDelete={onDelete}
               selected={selected}
               select={select}
               labels={enums.AdminResourceType.origin}
               resourceTypes={resourceTypes as string[]}
            />
            <FormFooterButtons cancel={onClose} />
         </Formik>
      </AsyncContainer>
   );
};

export default AdminRolesFormWrapper;
